import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import './DemographicDistributionChart.sass';

const BAR_BASE_COLOR = '#344563';
const BAR_HIGHLIGHT_COLOR = '#50b5d0';

const DemographicDistributionChart = ({ cities = [] }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const sortedCities = [...cities].sort((a, b) => b.total - a.total);
  const topCities = sortedCities.slice(0, 6);
  const totalProfiles = cities.reduce((sum, city) => sum + city.total, 0);

  return (
    <div className="demographic-distribution-bars">
      {topCities.map((city, index) => {
        const percentage =
          totalProfiles > 0
            ? Math.round((city.total / totalProfiles) * 100)
            : 0;

        return (
          <div
            key={`demo-bar-${index}`}
            className="demographic-bar"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <span
              className={`demographic-bar-hover-text ${hoveredIndex === index ? 'is-visible' : ''}`}
            >
              {`${I18n.t('dashboard.profiles')}: ${city.total} · ${percentage}%`}
            </span>
            <div className="demographic-bar-track">
              <div
                className="demographic-bar-fill"
                style={{
                  width: '100%',
                }}
              >
                <span className="demographic-bar-label">{city.name}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DemographicDistributionChart;
